import { getEnv } from "@/env";
import { useEffect, useRef } from "react";
import { cloneDeep } from "lodash";

let DEBUG_IN_TESTS = true;
let DEBUG_LOG_STACKS = false;
const IN_DEBUG_ENV = getEnv("JEST_WORKER_ID", false, false)
  ? DEBUG_IN_TESTS
  : ["acceptance", "staging", "local", "development"].includes(
      getEnv("VUE_APP_NODE_ENV")
    );

const Debug = Object.freeze({
  error: (...args) => IN_DEBUG_ENV && console.error(...args, Debug.stack("\n")),
  warn: (...args) => IN_DEBUG_ENV && console.warn(...args, Debug.stack("\n")),
  info: (...args) => IN_DEBUG_ENV && console.info(...args, Debug.stack("\n")),
  log: (...args) => IN_DEBUG_ENV && console.debug(...args, Debug.stack("\n")),
  usePreviousProps: (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  },
  stack: (prefix = "") => {
    if (!DEBUG_LOG_STACKS) {
      return "";
    }
    const err = new Error();
    const lines = err.stack.split("\n");
    const trimmedLines = lines.map((s) => s.trim()).slice(2);
    return prefix + trimmedLines.join("\n");
  },
});

export const snap = (value) => {
  // Stringification does not work with the Map class, the result is an empty object
  // So deep clone it instead and return that as the snapshot.
  if (value instanceof Map) {
    return cloneDeep(value);
  }
  return value ? JSON.parse(JSON.stringify(value)) : String(value);
};

export default Debug;

// For run-time debugging in DevTools. Use in the Console:
// > window.tap.toggleStacks()
window.tap = {
  Debug,
  snap,
  toggleStacks: () => (DEBUG_LOG_STACKS = !DEBUG_LOG_STACKS),
  toggleTestLogs: () => (DEBUG_IN_TESTS = !DEBUG_IN_TESTS),
};
